import { Component, Input, OnInit } from '@angular/core';
import { Router } from '@angular/router';
import { NgbModal } from '@ng-bootstrap/ng-bootstrap';
import { Subscription } from 'rxjs';
import { UpdateUserModel, UserDataResponseModel } from 'src/app/models/user/addUser.model';
import { AlertifyService } from 'src/app/services/Common/alertify.service';
import { LocalstorageService } from 'src/app/services/Common/localstorage.service';
import { UserService } from 'src/app/services/user.service';

@Component({
  selector: 'app-update-user',
  templateUrl: './update-user.component.html',
  styleUrls: ['./update-user.component.css']
})
export class UpdateUserComponent implements OnInit {
  userRoles: any[];
  userId: string;
  Loader: boolean = false;
  userSelectedRoleId: string;
  selectedActiveValue: string;
  selectedVerifiedValue: string;
  updateUser: UpdateUserModel;
  getuserdetail: UserDataResponseModel;
  userSub: Subscription;
  userRolesType: string;

  constructor(private localstorage: LocalstorageService, private _userService: UserService, private alertify: AlertifyService, private router: Router,
    private modalService: NgbModal) {
    this.localstorage.setMenu("2");
    this.updateUser = new UpdateUserModel();
    this.getuserdetail = new UserDataResponseModel();
  }

  ngOnInit() {
    this.userSub = this._userService.getUserId.subscribe((userId) => {
      this.userId = userId;
    });
    this.getUserRoles();
  }

  getUserRoles() {
    this._userService.userRoles().subscribe(response => {
      var responseBody = JSON.parse(response._body);
      if (responseBody.isSuccess) {
        this.userRoles = responseBody.responseData;
        this.getUserById();
      }
    });
  }

  selectRole(selectedUser) {
    this.userSelectedRoleId = selectedUser;
  }

  selectActive(selectedValue) {
    this.selectedActiveValue = selectedValue;
  }
  selectVerified(selectedValue) {
    this.selectedVerifiedValue = selectedValue;
  }

  onCancel() {
    this.modalService.dismissAll();
  }

  ngOnDestroy() {
    this.userSub.unsubscribe();
  }

  getUserById() {
    this._userService.getuserbyid(this.userId).subscribe((response) => {
      var responseBody = JSON.parse(response._body);
      this.getuserdetail = responseBody.responseData;
      this.updateUser.FirstName = this.getuserdetail.firstName;
      this.updateUser.LastName = this.getuserdetail.lastName;
      this.updateUser.Email = this.getuserdetail.email;
      this.updateUser.PhoneNumber = this.getuserdetail.phoneNumber;
      this.updateUser.UserType = this.getuserdetail.userType;
      this.userSelectedRoleId = this.updateUser.UserType;
      this.updateUser.IsActive = this.getuserdetail.isActive;
      this.selectedActiveValue = this.updateUser.IsActive ? "1" : "0";
      this.updateUser.IsVerified = this.getuserdetail.isVerified;
      this.selectedVerifiedValue = this.updateUser.IsVerified ? "1" : "0";
    });
  }


  onSubmit() {
    if (this.updateUser.FirstName == undefined || this.updateUser.FirstName == null || this.updateUser.FirstName == "") {
      this.alertify.error("First Name is required");
      return;
    }
    if (this.updateUser.LastName == undefined || this.updateUser.LastName == null || this.updateUser.LastName == "") {
      this.alertify.error("Last Name is required");
      return;
    }
    if (this.updateUser.Email == undefined || this.updateUser.Email == null || this.updateUser.Email == "") {
      this.alertify.error("Email is required");
      return;
    }
    if (this.updateUser.PhoneNumber == undefined || this.updateUser.PhoneNumber == null || this.updateUser.PhoneNumber == "") {
      this.alertify.error("Password is required");
      return;
    }
    this.Loader = true;
    this.updateUser.Id = this.userId;
    this.updateUser.UserType = this.userSelectedRoleId;
    this.updateUser.IsActive = this.selectedActiveValue;
    this.updateUser.IsVerified = this.selectedVerifiedValue;
    this._userService.updateUserDetail(this.updateUser).subscribe(response => {
      var responseBody = JSON.parse(response._body);
      if (responseBody.isSuccess) {
        this.updateUser = responseBody.responseData;
        this.alertify.success(responseBody.responseMessage);
        this.Loader = false;
        this.modalService.dismissAll();
      } else {
        this.alertify.error(responseBody.responseMessage);
        this.Loader = false;
      }
    });
  }
}
